import React from "react";
import { Redirect } from "react-router-dom";
import { withApollo } from "@apollo/react-hoc";
import { Row, Col, Collapse } from "reactstrap";
import Projects from "../../components/templates/projects";
import ProjectCard from "../../components/molecules/project-card";
import GenericModal from "../../components/organisms/modal";
import GenericForm from "../../components/organisms/form";
import ConfirmationModal from "../../components/organisms/confirmation-modal";
import Loading from "../../components/atoms/loading";

import { showToast, t, sluglify, GAevent, animateCSS } from "../../utils/utils";
import API from "../../api/API";
import { MY_PROJECTS, NEW_PROJECT, DELETE_PROJECT } from "../../api/projects";
import { GET_JWT, GET_REFRESH_JWT, EMPTY_VALIDATION } from "../../constants";
import Feedback from "../../components/templates/feedback";

class CreateProjectProcess extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      index: 0,
      msg: t("crearProyectoMensaje1"),
    };
    this.mensajes = [t("crearProyectoMensaje2"), t("crearProyectoMensaje3")];
    this.intervalID = 0;
  }

  componentDidMount() {
    this.intervalID = setInterval((e) => this.changeMsg(), 1500);
  }

  componentWillUnmount() {
    clearInterval(this.intervalID);
  }

  changeMsg() {
    const { index } = this.state;
    const { isCompleted } = this.props;
    if (
      this.mensajes.length < index ||
      (this.mensajes.length === index && isCompleted)
    ) {
      this.setState({ msg: t("crearProyectoMensajeOk") }, () => {
        setTimeout((e) => this.props.toNextStep(), 1500);
        clearInterval(this.intervalID);
      });
    } else if (this.mensajes.length === index && !isCompleted) {
      this.setState({
        msg: t("crearProyectoMensajeEspere"),
        index: index,
      });
    } else {
      this.setState(
        {
          msg: this.mensajes[index],
          index: index + 1,
        },
        () => animateCSS(".message-loading", "animate__fadeIn")
      );
    }
  }

  render() {
    return (
      <Row style={{ minHeight: "30vh", maxHeight: "50vh" }}>
        <Col xs="10" className="mb-1 mx-auto">
          <Loading width={370} height={300} animation={4} loop={false} />
        </Col>
        <Col xs="12" className="mb-4">
          <h6 className="text-center message-loading">{this.state.msg}</h6>
        </Col>
      </Row>
    );
  }
}

class ProjectsPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      redirect: null,
      modalNew: false,
      modalDelete: null,
      creating: false,
      deleting: false,
      projectData: [],
      formData: null,
      isValidForm: false,
      newProjectSlug: null,
      feedbackModal:
        props &&
        props.match &&
        props.match.params &&
        props.match.params.from !== undefined &&
        props.match.params.from !== "",
    };
  }

  // projectData: [
  //   { id: "asdf-1", name: "UBB", slug: "ubb" },
  //   { id: "asdf-2", name: "UdeC", slug: "udec" },
  //   { id: "asdf-3", name: "UCSC", slug: "ucsc" },
  //   { id: "asdf-4", name: "CasaW", slug: "casaw" }
  // ]

  componentDidMount() {
    if (GET_JWT() && GET_REFRESH_JWT()) {
      //se cargan los projectos del usuario
      this.getMyProjects();
    } else {
      showToast(t("ingreseNuevamenteEmailClave"), "error");
      this.setState({
        redirect: "/",
      });
    }
  }

  shouldComponentUpdate(prevProps, prevState) {
    return (
      this.state.loading !== prevState.loading ||
      this.state.modalNew !== prevState.modalNew ||
      this.state.modalDelete !== prevState.modalDelete ||
      this.state.deleting !== prevState.deleting ||
      this.state.creating !== prevState.creating ||
      this.state.newProjectSlug !== prevState.newProjectSlug ||
      this.state.redirect !== prevState.redirect
    );
  }

  async getMyProjects() {
    const { client } = this.props;
    try {
      const res = await API.query(client, MY_PROJECTS, {});
      if (res && res.data && res.data.getMyProjects) {
        //console.log(res.data.getMyProjects);
        this.setState({ projectData: res.data.getMyProjects });
      } else {
        showToast(t("errorCargarProyectos"), "error");
      }
    } catch ({ graphQLErrors, networkError }) {
      if (graphQLErrors && graphQLErrors.length > 0) {
        showToast(graphQLErrors[0].message, "error");
      } else if (networkError) {
        showToast(t("errorCargarProyectos"), "error");
      } else {
        showToast(t("errorCargarProyectos"), "error");
        this.setState({ redirect: "/" });
      }
    }
    this.setState({ loading: false });
  }

  async createProject() {
    const { formData, isValidForm } = this.state;
    const { client } = this.props;
    if (isValidForm && formData) {
      try {
        //se inicia la animacion de creación de projecto
        this.setState({ creating: true });
        //se general el slug, basado en el nombre del projecto
        const projectSlug = sluglify(formData.name);
        const res = await API.mutation(client, NEW_PROJECT, {
          project: {
            name: formData.name,
            slug: projectSlug,
            description: formData.description,
          },
        });
        if (res && res.data && res.data.createProject) {
          GAevent("Project", "NEW_PROJECT");
          this.setState({
            newProjectSlug: res.data.createProject.slug,
          });
        } else {
          showToast(t("errorCargarProyecto"), "error");
        }
      } catch ({ graphQLErrors, networkError }) {
        this.setState({ creating: false });
        if (graphQLErrors && graphQLErrors.length > 0) {
          showToast(graphQLErrors[0].message, "error");
        } else if (networkError) {
          showToast(t("errorCargarProyecto"), "error");
        } else {
          showToast(t("errorCargarProyecto"), "error");
          this.setState({ redirect: "/" });
        }
      }
    } else {
      showToast(t("corrijaErroresAntesCrearProyecto"), "error");
    }
  }

  deleteProject = async (id) => {
    const { client } = this.props;
    this.setState({ deleting: true });
    try {
      const res = await API.mutation(client, DELETE_PROJECT, {
        id: id,
      });
      if (res && res.data && res.data.deleteProject) {
        showToast(t("proyectoEliminadoExitosamente"));
        this.setState((prevState) => ({
          projectData: prevState.projectData.filter((p) => p.id !== id),
          modalDelete: null,
        }));
      } else {
        showToast(t("errorEliminarProyecto"), "error");
      }
    } catch ({ graphQLErrors, networkError }) {
      if (graphQLErrors && graphQLErrors.length > 0) {
        showToast(graphQLErrors[0].message, "error");
      } else if (networkError) {
        showToast(t("errorEliminarProyecto"), "error");
      } else {
        showToast(t("errorEliminarProyecto"), "error");
      }
    }
    this.setState({ deleting: false });
  };

  render() {
    const {
      loading,
      redirect,
      projectData,
      modalNew,
      modalDelete,
      deleting,
      creating,
      newProjectSlug,
      feedbackModal,
    } = this.state;
    console.log("feedbackModal", feedbackModal);
    if (redirect && !creating) return <Redirect to={redirect} />;
    const projects = [
      <ProjectCard
        key="new-project"
        new
        onClick={() => this.setState({ modalNew: true })}
      />,
    ].concat(
      projectData.map((p) => (
        <ProjectCard
          key={p.id}
          id={p.id}
          name={p.name}
          slug={p.slug}
          updatedAt={p.updatedAt}
          onDeleteProject={() => this.setState({ modalDelete: p.id })}
        />
      ))
    );

    return (
      <>
        <Projects projectContent={projects} loading={loading} />
        <GenericModal
          id="new-project-modal"
          isOpen={modalNew}
          title={t("crearProyecto")}
          primaryButtonText={t("crear")}
          closeButtonText={t("cerrar")}
          primaryButton
          primaryAction={() => this.createProject()}
          primaryActionInProcess={creating}
          closeAction={() =>
            this.setState((prevState) => ({ modalNew: !prevState.modalNew }))
          }
        >
          <Collapse isOpen={!creating}>
            <GenericForm
              id="new-project"
              setFormData={(data) => this.setState({ formData: data })}
              setValidForm={(result) => this.setState({ isValidForm: result })}
              fields={[
                {
                  name: "name",
                  type: "text",
                  label: t("nombre"),
                  placeholder: t("nuevoProyectoNombrePlaceholder"),
                  validations: [EMPTY_VALIDATION],
                },
                {
                  name: "description",
                  type: "textarea",
                  label: t("descripcion"),
                  placeholder: t("nuevoProyectoDescripcionPlaceholder"),
                  validations: [],
                },
              ]}
            />
          </Collapse>
          <Collapse isOpen={creating}>
            {creating && (
              <CreateProjectProcess
                isCompleted={newProjectSlug !== null}
                toNextStep={() =>
                  this.setState(
                    {
                      creating: false,
                      redirect: `/project/${newProjectSlug}`,
                      modalNew: false,
                    },
                    () => showToast(t("nuevoProyectoCreadoExitosamente"))
                  )
                }
              />
            )}
          </Collapse>
        </GenericModal>
        <ConfirmationModal
          id="delete-project-modal"
          isOpen={modalDelete !== null}
          title={t("estasSeguroDeEliminarProyecto")}
          primaryButtonText={t("confirmar")}
          primaryAction={() => this.deleteProject(modalDelete)}
          primaryActionInProcess={deleting}
          closeButtonText={t("cancelar")}
          closeAction={() => this.setState({ modalDelete: null })}
        />
        <Feedback
          isOpen={feedbackModal}
          project={this.props.match.params.from}
        />
      </>
    );
  }
}

// Title.defaultProps = {
//   className: '',
//   children: '',
// }

export default withApollo(ProjectsPage);
